import { useState } from 'react';
import { useLocation } from 'react-router';
import { addToLocalStorageArray } from '../../../components/Common/Validations';
import { useNotesFilters } from '../../AdvanceNotes/FilterQuery/NotesFilterQuery';
import { useFilter } from '../FilterQuery/FilterQuery';

function TagSVG({ id, text, count, sameTagsClickHandler }) {
	const location = useLocation();
	const isClientPage = location?.pathname?.includes('clients');
	const { addFilter } = location?.pathname?.includes('advance-notes') ? useNotesFilters() : useFilter();
	const doubleClickThreshold = 300;

	const [clickTimeout, setClickTimeout] = useState(null);

	const getTagStatus = () => {
		const includes = JSON.parse(localStorage.getItem(isClientPage ? 'tagCloudInclude' : 'notesTagCloudInclude')) || [];
		const excludes = JSON.parse(localStorage.getItem(isClientPage ? 'tagCloudExclude' : 'notesTagCloudExclude')) || [];

		const temp = JSON.parse(localStorage.getItem(isClientPage ? 'tempFilter' : 'tempNotesFilter')) || {};
		const tempIncluded = temp.includeTags || [];
		const tempExcluded = temp.excludeTags || [];

		if (includes.includes(text) || tempIncluded.includes(text)) return 'include';
		if (excludes.includes(text) || tempExcluded.includes(text)) return 'exclude';
		return 'neutral';
	};

	const getColors = () => {
		const status = getTagStatus();
		if (status === 'include') {
			return { bg: '#7DB00E', border: '#9FD629', text: 'white' };
		}
		if (status === 'exclude') {
			return { bg: '#ff0000', border: '#F74F4F', text: 'white' };
		}
		return { bg: '#D9D9D9', border: '#B6B6B6', text: 'black' };
	};

	const { bg: color1, border: color2, text: color3 } = getColors();

	const handleClick = () => {
		if (clickTimeout) {
			clearTimeout(clickTimeout);
			setClickTimeout(null);

			const includes = JSON.parse(localStorage.getItem(isClientPage ? 'tagCloudInclude' : 'notesTagCloudInclude')) || [];
			const excludes = JSON.parse(localStorage.getItem(isClientPage ? 'tagCloudExclude' : 'notesTagCloudExclude')) || [];

			if (excludes.includes(text)) {
				// Remove from exclude
				addFilter('excludeTags', text, true);
				localStorage.setItem(isClientPage ? 'tagCloudExclude' : 'notesTagCloudExclude', JSON.stringify(excludes.filter(item => item !== text)));
				sameTagsClickHandler(text, 'excludeTags', true);
			} else {
				if (includes.includes(text)) {
					addFilter('includeTags', text, true);
					localStorage.setItem(isClientPage ? 'tagCloudInclude' : 'notesTagCloudInclude', JSON.stringify(includes.filter(item => item !== text)));
					sameTagsClickHandler(text, 'includeTags', true);
				}

				addFilter('excludeTags', text);
				addToLocalStorageArray(isClientPage ? 'tagCloudExclude' : 'notesTagCloudExclude', text);
				sameTagsClickHandler(text, 'excludeTags');
			}
		} else {
			const newTimeout = setTimeout(() => {
				const includes = JSON.parse(localStorage.getItem(isClientPage ? 'tagCloudInclude' : 'notesTagCloudInclude')) || [];
				const excludes = JSON.parse(localStorage.getItem(isClientPage ? 'tagCloudExclude' : 'notesTagCloudExclude')) || [];

				if (includes.includes(text)) {
					addFilter('includeTags', text, true);
					localStorage.setItem(isClientPage ? 'tagCloudInclude' : 'notesTagCloudInclude', JSON.stringify(includes.filter(item => item !== text)));
					sameTagsClickHandler(text, 'includeTags', true);
				} else {
					if (excludes.includes(text)) {
						addFilter('excludeTags', text, true);
						localStorage.setItem(isClientPage ? 'tagCloudExclude' : 'notesTagCloudExclude', JSON.stringify(excludes.filter(item => item !== text)));
						sameTagsClickHandler(text, 'excludeTags', true);
					}

					addFilter('includeTags', text);
					addToLocalStorageArray(isClientPage ? 'tagCloudInclude' : 'notesTagCloudInclude', text);
					sameTagsClickHandler(text, 'includeTags');
				}

				setClickTimeout(null);
			}, doubleClickThreshold);

			setClickTimeout(newTimeout);
		}
	};

	return (
		<div
			className="d-flex pointer"
			onClick={handleClick}
		>
			<svg
				key={id}
				height="22"
				viewBox={`0 0 16 30`}
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M15.0659 0L29.9999 14.934L14.934 30L3.53548 18.6015C1.58286 16.6489 1.58285 13.4831 3.53547 11.5304L15.0659 0Z"
					fill={color1}
				/>
				<circle cx="9" cy="15.0001" r="2" fill="white" />
			</svg>
			<p className="clientTag" style={{ backgroundColor: color1, color: color3 }}>
				{text}
			</p>
			<p className="clientTag tagCount" style={{ backgroundColor: color2, color: color3 }}>
				{count}
			</p>
		</div>
	);
}

export default TagSVG;
